import React from 'react'
import { Img, Subgrid } from './Gallery.element'

function Galleryvideo() {
    return (
        <div style={{padding:'20px'}}>
        <Subgrid>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto1.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto2.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto3.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto4.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto5.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto7.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto8.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto9.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto10.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto11.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto12.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto13.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto14.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto15.JPG"></Img>
          <Img src="\website data for 2025-26\13_celebration photo\celebrationphoto16.JPG"></Img>
        </Subgrid>
    </div>
    )
}

export default Galleryvideo